import React from 'react';
import { motion } from 'framer-motion';
const items = ['Email Marketing', 'Sales Scripts', 'Instagram Captions', 'Cold Outreach', 'SEO Articles', 'Client Onboarding', 'Brainstorming', 'Productivity', 'Copywriting', 'Strategy'];
export function Marquee() {
  return <div className="w-full overflow-hidden bg-black border-y border-white/5 py-4 flex relative z-10" data-id="element-237">
      <motion.div animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 20,
      ease: 'linear',
      repeat: Infinity
    }} className="flex whitespace-nowrap" data-id="element-238">
        {[...items, ...items, ...items, ...items].map((item, i) => <div key={i} className="flex items-center" data-id="element-239">
            <span className="text-muted text-xs font-bold uppercase tracking-[0.2em] mx-8" data-id="element-240">
              {item}
            </span>
            <span className="text-gold/30" data-id="element-241">•</span>
          </div>)}
      </motion.div>
    </div>;
}